module.exports = __webpack_public_path__ + "static/media/iraq-large.ca8fb221.jpg";